export const KIOSK_PATHNAME = "/kiosk";
export const KIOSK_HEALTH_CHECK = "Health Check";
export const KIOSK_HEALTH_METRICS = "KIOSK_HEALTH_METRICS";
export const KIOSK_LOCATION_WARNING = "Kiosk Location Warning";
